import { createFeatureSelector, createSelector } from '@ngrx/store';
import { ScopesState } from '../interfaces/scopes-state.interface';
import { SCOPES_FEATURE_NAME } from './scopes.actions';

const scopesFeatureSelector = createSelector(
  createFeatureSelector<ScopesState>(SCOPES_FEATURE_NAME),
  state => state,
);

export const scopes = createSelector(
  scopesFeatureSelector,
  state => state.scopes,
);

export const loading = createSelector(
  scopesFeatureSelector,
  state => state.loading,
);
